import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


//禁止全局路由错误打印 去掉不影响功能
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    // mode:'history',
    routes: [
        //商品
        {
            path: '/',
            redirect: '/home',
            meta: {isNOlog: false},
            component: resolve => require(['@/views/home'], resolve),
            children: [
                {
                    path: '/home',
                    meta: {showLeft: true},
                    component: resolve => require(['@/views/home/index'], resolve)
                },
                {
                    path: '/goodsSearch',
                    component: resolve => require(['@/views/goods/searchIndex'], resolve)
                },
                {
                    path: '/detailsIndex',
                    component: resolve => require(['@/views/goods/detailsIndex'], resolve)
                },
                //分类
                {
                    path: '/type',
                    name: 'type',
                    component: resolve => require(['@/views/type/type'], resolve),
                },
                //品牌列表
                {
                    path: '/brandlist',
                    name: 'brandlist',
                    meta: {title: '品牌列表'},
                    component: resolve => require(['@/views/brandlist/brandlist'], resolve),
                },
                {
                    path: '/quickorder',
                    name: 'quickorder',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/quickorder/quickorder'], resolve),
                },
                {
                    path: '/articlelist',
                    name: 'articlelist',
                    component: resolve => require(['@/views/article/articlelist'], resolve),
                },
                {
                    path: '/article',
                    name: 'article',
                    component: resolve => require(['@/views/article/article'], resolve),
                },
                //底部导航指南
                {
                    path: '/guide',
                    name: 'guide',
                    component: resolve => require(['@/views/guide/guide'], resolve),
                }
            ]
        },

        // 购物车
        {
            path: '/cart',
            name: 'cart',
            redirect: '/cart/cartList',
            component: resolve => require(['@/views/publicView/ShoppingProcess'], resolve),
            children: [
                {
                    path: 'cartList',
                    meta: {process: 0, isNOlog: true},
                    component: resolve => require(['@/views/cart/cartList'], resolve)
                },
                {
                    path: 'order',
                    meta: {process: 1, isNOlog: true},
                    component: resolve => require(['@/views/confirmOrder/confirmOrder'], resolve)
                },
                {
                    path: 'pay',
                    meta: {process: 2, isNOlog: true},
                    component: resolve => require(['@/views/pay/payinformation'], resolve)
                }
            ]
        },
        //登录
        {
            path: '/auto',
            name: 'auto',
            redirect: '/auto/login',
            component: resolve => require(['@/views/publicView/door'], resolve),
            children: [
                {
                    path: 'login',
                    component: resolve => require(['@/views/auto/login'], resolve)
                },
                {
                    path: 'register',
                    component: resolve => require(['@/views/auto/register'], resolve)
                },
                {
                    path: 'retrievePwd',
                    component: resolve => require(['@/views/auto/retrievePwd'], resolve)
                }
            ]
        },

        //个人中心
        {
            path: '/center',
            name: 'center',
            // redirect: '/center/personal',
            meta: {isNOlog: true},
            component: resolve => require(['@/views/publicView/center'], resolve),
            children: [
                {
                    path: 'personal',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/personalCenter/personal'], resolve)
                },
                {
                    path: 'securitySet',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/personalCenter/securitySet'], resolve)
                },
                {
                    path: 'collection',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/personalCenter/collection'], resolve)
                },
                {
                    path: 'notice',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/personalCenter/notice'], resolve)
                },
                {
                    path: 'pendingPayment',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/order/pendingPayment'], resolve)
                },
                {
                    path: 'invoiceManager',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/invoice/invoiceManager'], resolve)
                },
                {
                    path: 'allAddress',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/addressMaager/allAddress'], resolve)
                },
                {
                    path: 'orderInfo',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/order/orderInfo'], resolve)
                },
                {
                    path: 'logistics',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/logistics/logistics'], resolve)
                },
                {
                    path: 'company',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/company/company'], resolve)
                },
                {
                    path: 'combination',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/company/combination'], resolve)
                },
                {
                    path: 'costCenter',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/company/costCenter'], resolve)
                },
                {
                    path: 'member',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/company/member'], resolve)
                },
                {
                    path: 'approval',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/company/approval'], resolve)
                },
                {
                    path: 'statistics',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/company/statistics'], resolve)
                },
                {
                    path: 'PurchaserOrApproval',
                    meta: {isNOlog: true},
                    component: resolve => require(['@/views/PurchaserOrApproval/index'], resolve)
                },
            ]
        },
    ],
    //页面跳转 会定位到顶部
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js